import React, { useState } from 'react';
import VoucherRail from '@/components/vouchers/VoucherRail';
import { useNavigate } from 'react-router-dom';
import useHighBuildOrder from '@/components/proepoxy/hooks/useHighBuildOrder';
import HighBuildModePicker from '@/components/proepoxy/highbuild-flow/HighBuildModePicker';
import HighBuildManualFlow from '@/components/proepoxy/highbuild-flow/HighBuildManualFlow';
import HighBuildGuidedFlow from '@/components/proepoxy/highbuild-flow/HighBuildGuidedFlow';

const HighBuildEpoxyFlow = ({ currentStep, goToStep, onExit, highBuildOrderMode, setHighBuildOrderMode }) => {
  const navigate = useNavigate();
  const [priority, setPriority] = React.useState('no_rush');
  const hb = useHighBuildOrder();
  const [voucher, setVoucher] = useState({ id: null, value: 0 });
  const voucherAreaM2 = (hb.highBuildAreas || []).reduce((a, x) => a + (parseFloat(x.m2) || 0), 0);

  const childProps = {
    state: hb,
    priority,
    setPriority,
    currentStep,
    goToStep,
    highBuildOrderMode,
    voucher,
    setHighBuildOrderMode,
    navigate,
    onExit,
  };

  return (
    <>
      {currentStep === 1 && !highBuildOrderMode && (
        <HighBuildModePicker {...childProps} />
      )}
      {highBuildOrderMode === 'manual' && (
        <HighBuildManualFlow {...childProps} />
      )}
      {highBuildOrderMode === 'guided' && (
        <HighBuildGuidedFlow {...childProps} />
      )}
      {highBuildOrderMode && <div className="mt-6"><VoucherRail brand="proepoxy" system="high_build" areaM2={voucherAreaM2} items={(hb.manualOrder?.highBuildItems || []).concat(hb.manualOrder?.primerItems || []).map((it) => ({ name: it.name || it.product_name || '', qty: it.qty || it.quantity || 0 }))} selectedId={voucher.id} onSelect={(id, value) => setVoucher({ id, value })} accent="#F5B301" /></div>}
    </>
  );
};

export default HighBuildEpoxyFlow;
